// Necessary Imports
import React, {useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import SglContext from "../SglContext";


function CircuitStanding(props) {
  // States
      const Sgl = useContext(SglContext)
      const [circuits_list, setCircuits_list] = useState([])
      const [circuit, setCircuit] = useState({})
      const [circuit_id, setCircuit_id] = useState(0)
      const [circuit_divisions, setCircuit_divisions] = useState([])
      const [show_name, setShow_name] = useState([])
      const [current_show, setCurrent_show] = useState(localStorage.getItem("show_id"))
      const [loading, setLoading] = useState(true)

      // Api EndPoints
      const sgl_webservice_results = Sgl.nestApiUrl+'/results/circuitStanding';

      // ComponentDidMount (This will trigger first)
  //     useEffect(() => { 
  //     getAllData(circuit_id, current_show)
  // }, [])

    useEffect(() => {
      getCircuitData(0, props.currentShow);
    }, [props.currentShow])

    function getCircuitData(circuit_id, show){
        axios.get(sgl_webservice_results,{
          params : {
                circuit_id : circuit_id,
                show_id : show,
                customer_id: Sgl.company_id
          }
        }).then(res => {
          setCircuits_list(res.data.circuits_list)
          setCircuit(res.data.circuit)
          setCurrent_show(res.data.show_id)
          setCircuit_id(res.data.circuit_id)
          setCircuit_divisions(res.data.circuit_divisions)
          setShow_name(res.data.show_name)
          setLoading(false)
          document.title = "Results for " + res.data.show_name;
          Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/circuitstandings/list/circuit/'+circuit_id);  //For google Analytics
          Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+show+'/circuitstandings/list/circuit/'+circuit_id);  //For facebook Analytics
      })
      
    }
    
    // function getAllData(circuit_id, show){   
    //   getCircuitData(circuit_id, current_show)
    // }

    function onCircuitChange(e) {
        let circuit_id = e.target.value;
        getCircuitData(circuit_id, current_show);
    }

      if(loading) {
        return null;
      }

      return(
        <div className="section-to-print">
        <section className="search-area">
          <h2 className="sgl-h2">Results for {show_name}</h2>

          {(circuits_list.length > 0) &&
            <section className="search-area">
              <table>
                <tbody>
                  <tr><span className='sponsor_text'>Select Circuit: </span> 
                    <select className="selection-list" value={circuit_id} onChange={(e) => onCircuitChange(e)}>
                        {
                          circuits_list.map((circuit,index) => {
                            return (
                              <option key={circuit.circuit_id} value={`${circuit.circuit_id}`}>{circuit.name}</option>
                            )
                          })
                        }
                    </select>
                  </tr>
                </tbody>
              </table>
            </section>
          }

<div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>

          {(circuit_divisions.length > 0) ?
            <div className="div-responsive">
              <div className='jumper-p'><span className='sponsor_text'>Standings:</span> {circuit.name}</div>
              <table className="table table-striped table-hover">
                <thead className="classes-header">
                  <tr className="sgl-primary-header">
                        <th>Name</th>
                        <th>USEF Sec.</th>
                        <th>Based On</th>
                        <th>Calc. Method</th>
                  </tr>
                </thead>
                <tbody>             
                  { 
                    circuit_divisions.map((data, index) => {
                      return (
                        <tr key={data.circuit_division_id} className="sgl-anchor">


                        <td><Link to={'/circuitstanding/detail' + '?div_id=' + data.circuit_division_id + '&circuit_id='+ circuit_id+'&sid='+current_show}>{data.name}</Link></td>

                        <td><Link to={"/circuitstanding/detail" + '?div_id=' + data.circuit_division_id + '&circuit_id='+ circuit_id+'&sid='+current_show}>{(data.usef_section)?data.usef_section:'-'}</Link></td>
                        <td><Link to={"/circuitstanding/detail" + '?div_id=' + data.circuit_division_id + '&circuit_id='+ circuit_id+'&sid='+current_show}>{data.standingsselectionmethod}</Link></td>
                        <td><Link to={"/circuitstanding/detail" + '?div_id=' + data.circuit_division_id + '&circuit_id='+ circuit_id+'&sid='+current_show}>{data.standingsbasedon}/{data.standingscalmethod == 'Linear'?'From Classes':data.standingscalmethod}</Link></td>

                        </tr>
                      )
                    })
                  }            
                  
                </tbody>
              </table>
            </div>
          : 
            <table>
              <tbody>
                <tr>
                  <td>No Circuit Divisions found.</td>
                </tr>
              </tbody>
            </table>
          }
          <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </section>
        </div>
      )
  }
  export default CircuitStanding